import { ClusterOptionType } from "../../../../components/pages/kubernetes-live-usage-mgmt/components/navigation/selected-cluster/components/utils/types";

export const sortClusterOptionTypeByOrgIdCompareFn = (
  first: ClusterOptionType,
  second: ClusterOptionType,
) => first.clusterId?.localeCompare(second.clusterId ?? "") ?? 1;
